module.exports = __webpack_public_path__ + "static/media/Flow_ShopeePay_App.23fc9c85.png";